(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[219],{

/***/ 1891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Single; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/Header/index.tsx + 3 modules
var Header = __webpack_require__(98);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 30 modules
var format = __webpack_require__(3621);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/locale/pt-BR/index.js + 5 modules
var pt_BR = __webpack_require__(9081);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(5935);
;// CONCATENATED MODULE: ./src/hooks/use-summary.tsx

function useSummary() {
  var _useState = (0,react.useState)([]),
      summary = _useState[0],
      setSummary = _useState[1];

  function summarizer() {
    var subtitles = document.getElementsByTagName('h2');
    var summaryItems = Array.from(subtitles).map(function (subtitle) {
      var _subtitle$textContent;

      var id = subtitle.textContent ? subtitle.textContent.replace(/\s/g, '-') : '';
      subtitle.id = id;
      return {
        id: id,
        name: (_subtitle$textContent = subtitle.textContent) !== null && _subtitle$textContent !== void 0 ? _subtitle$textContent : ''
      };
    });
    delete summaryItems[summaryItems.findIndex(function (item) {
      return (item === null || item === void 0 ? void 0 : item.name) === 'VOCÊ TAMBÉM PODE SE INTERESSAR POR:';
    })];
    delete summaryItems[summaryItems.findIndex(function (item) {
      return (item === null || item === void 0 ? void 0 : item.name) === 'ASSUNTOS MAIS RELEVANTES:';
    })];
    setSummary(summaryItems);
  }

  return {
    summarizer: summarizer,
    summary: summary
  };
}
// EXTERNAL MODULE: ./node_modules/react-share/es/LinkedinShareButton.js
var LinkedinShareButton = __webpack_require__(3597);
// EXTERNAL MODULE: ./node_modules/react-share/es/WhatsappShareButton.js
var WhatsappShareButton = __webpack_require__(2834);
// EXTERNAL MODULE: ./node_modules/react-share/es/FacebookShareButton.js
var FacebookShareButton = __webpack_require__(6573);
// EXTERNAL MODULE: ./node_modules/react-share/es/TwitterShareButton.js
var TwitterShareButton = __webpack_require__(6616);
// EXTERNAL MODULE: ./node_modules/react-share/es/TelegramShareButton.js
var TelegramShareButton = __webpack_require__(8168);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(9583);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
;// CONCATENATED MODULE: ./src/components/ShareButtons/styles.ts

var ButtonsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__ButtonsContainer",
  componentId: "sc-117klxn-0"
})(["display:flex;justify-content:center;align-items:center;gap:1.5rem;margin:0 auto;max-width:30rem;padding:3rem 0 1rem;button{transition:filter 0.3s ease-in-out;&:hover,&:focus{filter:brightness(0.8);}}@media (min-width:1024px){padding-bottom:0;}"]);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/ShareButtons/index.tsx





function ShareButtons(_ref) {
  var slug = _ref.slug;
  var url = "https://kenzie.com.br/blog/".concat(slug);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonsContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkedinShareButton/* default */.Z, {
      url: url,
      style: {
        fontSize: '2.5rem',
        color: '#0e76a8',
        marginTop: '0.5rem',
        display: 'flex',
        alignItems: 'center'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaLinkedinIn */.BUd, {
        style: {
          fontSize: '100%'
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhatsappShareButton/* default */.Z, {
      url: url,
      style: {
        fontSize: '2.5rem',
        color: '#25d366',
        marginTop: '0.5rem',
        display: 'flex',
        alignItems: 'center'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaWhatsapp */.xpo, {
        style: {
          fontSize: '100%'
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FacebookShareButton/* default */.Z, {
      url: url,
      style: {
        fontSize: '2.5rem',
        color: '#1877f2',
        marginTop: '0.5rem',
        display: 'flex',
        alignItems: 'center'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaFacebookF */.tBk, {
        style: {
          fontSize: '100%'
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TwitterShareButton/* default */.Z, {
      url: url,
      style: {
        fontSize: '2.5rem',
        color: '#00acee',
        marginTop: '0.5rem',
        display: 'flex',
        alignItems: 'center'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaTwitter */.fWC, {
        style: {
          fontSize: '100%'
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TelegramShareButton/* default */.Z, {
      url: url,
      style: {
        fontSize: '2.5rem',
        color: '#34A2E0',
        marginTop: '0.5rem',
        display: 'flex',
        alignItems: 'center'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaTelegram */.Ww5, {
        style: {
          fontSize: '100%'
        }
      })
    })]
  });
}
;// CONCATENATED MODULE: ./src/components/PostContent/categories.ts
var categories = {
  1379: {
    name: 'Back-End',
    slug: 'back-end'
  },
  1362: {
    name: 'Carreira',
    slug: 'carreira'
  },
  1382: {
    name: 'CSS',
    slug: 'css'
  },
  1363: {
    name: 'Cultura Tech',
    slug: 'cultura-tech'
  },
  1378: {
    name: 'Front-End',
    slug: 'front-end'
  },
  1383: {
    name: 'HTML',
    slug: 'html'
  },
  1364: {
    name: 'Institucional',
    slug: 'institucional'
  },
  1384: {
    name: 'Javascript',
    slug: 'javascript'
  },
  1366: {
    name: 'Mercado de Trabalho',
    slug: 'mercado-de-trabalho'
  },
  1381: {
    name: 'Programação',
    slug: 'programacao'
  },
  1367: {
    name: 'Tecnologia',
    slug: 'tecnologia'
  },
  1385: {
    name: 'Python',
    slug: 'python'
  },
  1: {
    name: 'Uncategorized',
    slug: 'uncategorized'
  }
};
;// CONCATENATED MODULE: ./src/components/PostContent/styles.ts

var PostContainer = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
  displayName: "styles__PostContainer",
  componentId: "sc-1eqpxcd-0"
})(["padding-top:8rem;width:85%;max-width:var(--max-width);border-bottom:1px solid #dddddd;margin:0 auto;h1{font-size:1.625rem;font-weight:800;color:var(--highlight-blue);margin-bottom:2.5rem;text-transform:uppercase;}@media (min-width:1024px){padding:9.35rem 0 2.5rem;h1{margin-bottom:1.25rem;font-size:2.25rem;}}"]);
var PostWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__PostWrapper",
  componentId: "sc-1eqpxcd-1"
})(["max-width:700px;margin:0 auto;p{margin-bottom:1.5rem;line-height:1.8;}p,ul,ol{font-size:1.125rem;}h2,h3,h4,h5,h6{font-family:'Open Sans',sans-serif;margin-bottom:1.5rem;font-size:1.5rem;}ul{list-style-type:disc;padding:0 0 0 40px;margin-bottom:1.5rem;}ol{margin:0 0 1.5rem;}li{list-style-type:unset;padding:unset;}img{width:100%;object-fit:cover;margin-bottom:3rem;}a{color:var(--highlight-blue);font-weight:700;text-decoration:underline;}@media (min-width:1024px){p,a,strong{font-size:1.125rem;}}"]);
var Author = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Author",
  componentId: "sc-1eqpxcd-2"
})(["display:flex;align-items:center;margin-bottom:0.5rem;flex-wrap:wrap;row-gap:1rem;font-weight:700;padding-bottom:2rem;border-bottom:1px solid #a0a0a0;margin:2rem 0 3rem;img{object-fit:contain;border-radius:50%;margin-right:0.625rem;}p{.name{font-weight:700;display:inline-block;border-right:1px solid #000;padding-right:0.5rem;margin-right:0.5rem;}.date{font-family:'Jet Brains',monospace;font-size:0.875rem;font-weight:800;display:inline-block;border-right:1px solid #000;padding-right:0.5rem;margin-right:0.5rem;}.duration{font-size:0.875rem;font-weight:400;}@media (min-width:1024px){margin-bottom:0;}}"]);
var Breadcrumbs = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Breadcrumbs",
  componentId: "sc-1eqpxcd-3"
})(["margin-left:auto;font-family:'Open Sans',sans-serif;font-size:0.8rem;font-weight:400;transition:color 0.3s ease-in-out;.separator{color:var(--highlight-blue);}a:hover{color:var(--highlight-blue);}"]);
var Summary = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Summary",
  componentId: "sc-1eqpxcd-4"
})(["display:flex;flex-direction:column;gap:1rem;padding-bottom:1.5rem;.summary-link{text-decoration:underline;color:blue;font-size:0.875rem;span{font-weight:700;}&:hover{color:var(--highlight-blue);}}"]);
;// CONCATENATED MODULE: ./src/components/PostContent/index.tsx












function PostContent(_ref) {
  var _categories$postCateg, _categories$postCateg2, _categories$postCateg3, _categories$postCateg4, _post$content;

  var post = _ref.post,
      author = _ref.author;
  var postCategory = post.category;

  var _useSummary = useSummary(),
      summarizer = _useSummary.summarizer,
      summary = _useSummary.summary;

  (0,react.useEffect)(function () {
    summarizer();
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(PostContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      children: post.title
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Author, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: author.avatarUrl,
        alt: author.name,
        width: 50,
        height: 50,
        unoptimized: true
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Por ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "name",
          children: author.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "date",
          children: (0,format/* default */.Z)(new Date(post.date), 'dd MMM yyyy', {
            locale: pt_BR/* default */.Z
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: "duration",
          children: [post.readingTime, " min de leitura"]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Breadcrumbs, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/",
          legacyBehavior: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            children: "Inicio"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "separator",
          children: " \xBB "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/categorias/".concat((_categories$postCateg = (_categories$postCateg2 = categories[postCategory]) === null || _categories$postCateg2 === void 0 ? void 0 : _categories$postCateg2.slug) !== null && _categories$postCateg !== void 0 ? _categories$postCateg : 'uncategorized'),
          legacyBehavior: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            children: (_categories$postCateg3 = (_categories$postCateg4 = categories[postCategory]) === null || _categories$postCateg4 === void 0 ? void 0 : _categories$postCateg4.name) !== null && _categories$postCateg3 !== void 0 ? _categories$postCateg3 : 'Uncategorized'
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PostWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: post.media,
        alt: "Imagem ilustrativa",
        width: 700,
        height: 200,
        unoptimized: true
      }), summary ? /*#__PURE__*/(0,jsx_runtime.jsx)(Summary, {
        children: summary.map(function (i, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            href: "#".concat(i.id),
            className: "summary-link",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "".concat(index + 1, ".")
            }), " ", i.name]
          }, index);
        })
      }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: (0,html_react_parser/* default */.ZP)((_post$content = post.content) !== null && _post$content !== void 0 ? _post$content : '')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ShareButtons, {
        slug: post.slug
      })]
    })]
  });
}
// EXTERNAL MODULE: ./src/components/CategoriesSection/index.tsx + 3 modules
var CategoriesSection = __webpack_require__(6651);
// EXTERNAL MODULE: ./src/components/PostCard/index.tsx + 2 modules
var PostCard = __webpack_require__(9252);
;// CONCATENATED MODULE: ./src/components/SimilarPosts/styles.ts

var Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "styles__Container",
  componentId: "sc-2xrwjp-0"
})(["padding:2.5rem 0;margin:0 auto;max-width:var(--max-width);width:85%;@media (min-width:1024px){padding:4.25rem 0;}"]);
var List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styles__List",
  componentId: "sc-2xrwjp-1"
})(["display:flex;flex-wrap:wrap;justify-content:flex-start;gap:2.5rem 3.6rem;margin:0 auto;@media (max-width:1200px){gap:1.5rem 3rem;justify-content:center;}"]);
var PaginationContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__PaginationContainer",
  componentId: "sc-2xrwjp-2"
})(["margin:0 auto;padding:4.5rem 0 2.5rem;width:fit-content;"]);
var Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "styles__Title",
  componentId: "sc-2xrwjp-3"
})(["font-size:1.625rem;font-weight:800;color:var(--brand-color);margin-bottom:2.5rem;text-transform:uppercase;@media (min-width:1024px){margin-bottom:4.5rem;font-size:2.25rem;}"]);
;// CONCATENATED MODULE: ./src/components/SimilarPosts/index.tsx




function SimilarPosts(_ref) {
  var posts = _ref.posts;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      color: "#2d2d2d",
      children: "VOC\xCA TAMB\xC9M PODE SE INTERESSAR POR:"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(List, {
      children: posts.map(function (post, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(PostCard/* default */.Z, {
          post: post,
          showCategory: true,
          isLoading: false
        }, index);
      })
    })]
  });
}
;// CONCATENATED MODULE: ./src/pages/[slug].tsx









var __N_SSG = true;
function Single(_ref) {
  var _props$children;

  var post = _ref.post,
      author = _ref.author,
      featuredPosts = _ref.featuredPosts;
  var parsedDescription = (0,html_react_parser/* default */.ZP)(post.description);
  var props = parsedDescription[0].props;
  var description = (_props$children = props === null || props === void 0 ? void 0 : props.children) !== null && _props$children !== void 0 ? _props$children : '';
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: post.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: description
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:title",
        content: "Kenzie Academy Brasil: Curso de Programa\xE7\xE3o Online"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:description",
        content: "Torne-se um desenvolvedor em 12 meses com o curso de programa\xE7\xE3o online da Kenzie Academy Brasil e comece a pagar ap\xF3s estar empregado. Confira!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Kenzie Academy Brasil: Curso de Programa\xE7\xE3o Online"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://kenzie.com.br/blog/".concat(post.slug)
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("main", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PostContent, {
        post: post,
        author: author
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SimilarPosts, {
        posts: featuredPosts
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CategoriesSection/* default */.Z, {})]
    })]
  });
}

/***/ }),

/***/ 8232:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]",
      function () {
        return __webpack_require__(1891);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [445,692,173,93,450,774,888,179], function() { return __webpack_exec__(8232); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);